// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class MarketSummary {
  readonly id: string;
  readonly name: string;
  readonly address: string | null;
  readonly phoneNumber: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.address = data.address === undefined ? null : data.address;
    this.phoneNumber = data.phoneNumber === undefined ? null : data.phoneNumber;
  }

  static zero(): MarketSummary {
    const zeroValues: ExcludeMethodsDeep<MarketSummary> = {
      id: NIL_UUID,
      name: '',
      address: null,
      phoneNumber: null,
    };
    return new MarketSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MarketSummaryWireFormat = {
  id: string;
  name: string;
  address: string | null;
  phoneNumber: string | null;
};

type NewMarketSummaryProps = PartialDeep<MarketSummary, { recurseIntoArrays: true }>;
export const NewMarketSummary: (props: NewMarketSummaryProps) => MarketSummary = (props) =>
  new MarketSummary(props);

type NewMarketSummaryFromWireFormatProps = PartialDeep<
  MarketSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMarketSummaryFromWireFormat: (
  props: NewMarketSummaryFromWireFormatProps,
) => MarketSummary = (props) => new MarketSummary(props);
